/**
 * Button shells — keep base minimal; variants only set color + border.
 * Prefer size="cta" for page actions; dense toolbars use size="sm".
 *
 * Note: do not put border-transparent on base — with preflight:false /
 * Tailwind source order, it can override variant border colors.
 */

const base =
    "btn box-border inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-solid font-sans font-semibold no-underline transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-accent-20 disabled:pointer-events-none disabled:cursor-not-allowed [&_svg]:size-[1em] [&_svg]:shrink-0";

const filledDisabled = "disabled:opacity-60";

const variants = {
    primary:
        `border-button-primary-hover bg-button-primary text-text-inverse hover:bg-button-primary-hover disabled:border-button-primary disabled:bg-button-primary disabled:hover:bg-button-primary ${filledDisabled}`,
    secondary:
        `border-button-secondary-hover bg-button-secondary text-text-inverse hover:bg-button-secondary-hover disabled:border-button-secondary disabled:bg-button-secondary disabled:hover:bg-button-secondary ${filledDisabled}`,
    tertiary:
        "border-button-primary bg-transparent text-button-primary hover:bg-accent-10 hover:border-button-primary-hover hover:text-button-primary-hover disabled:border-border disabled:bg-transparent disabled:text-text-muted disabled:opacity-60",
    danger:
        `border-button-danger-hover bg-button-danger text-text-inverse hover:bg-button-danger-hover disabled:border-button-danger disabled:bg-button-danger disabled:hover:bg-button-danger ${filledDisabled}`,
    success:
        `border-button-success-hover bg-button-success text-text-inverse hover:bg-button-success-hover disabled:border-button-success disabled:bg-button-success disabled:hover:bg-button-success ${filledDisabled}`,
    warning:
        `border-button-warning-hover bg-button-warning text-text-inverse hover:bg-button-warning-hover disabled:border-button-warning disabled:bg-button-warning disabled:hover:bg-button-warning ${filledDisabled}`,
};

const sizes = {
    sm: "min-h-7 min-w-12 px-2 py-1.5 text-xs leading-5 [&_svg]:size-[0.875em]",
    /* Fixed control sizes — do not scale up with viewport width */
    md: "min-h-8 min-w-16 px-2.5 py-1.5 text-sm leading-5",
    lg: "min-h-9 min-w-[4.5rem] px-3 py-2 text-sm leading-6 [&_svg]:size-[1.125em]",
    cta: "min-h-9 min-w-[4.5rem] px-3 py-2 text-sm font-semibold leading-6 [&_svg]:size-[1.125em]",
};

export const buttonShell = {
    base,
    sizes,
    variants,
};

/**
 * @param {"primary"|"secondary"|"tertiary"|"danger"|"success"|"warning"} variant
 * @param {"sm"|"md"|"lg"|"cta"} size
 * @param {string} [className]
 */
export function buttonClass(variant = "primary", size = "md", className = "") {
    const variantClass = variants[variant] || variants.primary;
    const sizeClass = sizes[size] || sizes.md;
    return `${base} ${variantClass} ${sizeClass} ${className}`.trim();
}
